const standardizeEmail = (email) => {
  if(email && typeof email === 'string') {
    email = email.trim();
    email = email.toLowerCase();
    return email;
  } else {
    console.error('Email must be a string');
    return null;
  }
}

export default standardizeEmail;



// WEBPACK FOOTER //
// ./src/common/standardizeEmail.js